import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
const state = {
    arrMessage: [],
    arrMessageDetail: []
};
const getters = {
    listingMessage: () => state.arrMessage,
    listingMessageDetail: () => state.arrMessageDetail
};

const actions = {
    [actionType.GET_LISTING_USER_MESSAGE]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get('/user/messages', {
                params: {
                    page: params.page,
                    take: params.take,
                    search: params.search
                }
            }).then(result => {
                if(result.data.data) {
                    let response = {
                        page: params.page,
                        data: result.data.data
                    }
                    commit(mutationType.SET_LISTING_USER_MESSAGE, response)
                }
                //commit(mutationType.SET_LISTING_USER_MESSAGE_DETAIL, [])
                resolve(result)
            })
            .catch(error => reject(error));
        });
    },
    [actionType.GET_LISTING_USER_MESSAGE_DETAIL]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get(`/user/messages/${params.id}`, {
                params: {
                    page: params.page,
                    take: params.take
                }
            })
            .then(result => {
                if(result.data.data) {
                    let response = {
                        page: params.page,
                        data: result.data.data
                    }
                    commit(mutationType.SET_LISTING_USER_MESSAGE_DETAIL, response)
                    commit(mutationType.UPDATE_LISTING_USER_MESSAGE, params.id)
                }
                resolve(result)
            })
            .catch(error => reject(error));
        });
    },
    // [actionType.MARK_READ_USER_MESSAGE]: async function ({ commit }, params) {
    //     return new Promise((resolve, reject) => {
    //         api.put(`/user/messages/mark-as-read/${params.id}`)
    //         .then(result => {
    //             if(result.success) {
    //                 commit(mutationType.UPDATE_LISTING_USER_MESSAGEL, params.index)
    //             }
    //             resolve(result)
    //         })
    //         .catch(error => reject(error));
    //     });
    // }
};

const mutations = {
    [mutationType.SET_LISTING_USER_MESSAGE]: function (state, data) {
        if(data.data.length > 0) {
            if(data.page == 1) {
                state.arrMessage = data.data
            }
            else {
                state.arrMessage = state.arrMessage.concat(data.data);
            }
        }
    },
    [mutationType.SET_LISTING_USER_MESSAGE_DETAIL]: function (state, data) {
        if(data.data.length > 0) {
            if(data.page == 1) {
                state.arrMessageDetail = data.data
            }
            else {
                state.arrMessageDetail = state.arrMessageDetail.concat(data.data);
            }
        }
    },
    [mutationType.UPDATE_LISTING_USER_MESSAGE]: function (state, id) {
        if(state.arrMessage.length > 0) {
            let indx = state.arrMessage.findIndex(item => item.id == id)
            if(indx != -1) {
                state.arrMessage[indx].unread = 0;
            }
        }
    },
    "RESET_LISTING_USER_MESSAGE": function(state) {
        state.arrMessage = []
        state.arrMessageDetail = []
    },
    "RESET_LISTING_USER_MESSAGE_DETAIL": function(state) {
        state.arrMessageDetail = []
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}